import React, { useState, useEffect } from "react";
import InputLabel from "@material-ui/core/InputLabel";
//import { ThemeProvider } from "@material-ui/core";
import Box from '@material-ui/core/Box';
import { lightTheme } from "../../SharedComponents/SharedComponentStyles";
import FormControl from "@material-ui/core/FormControl";
import { Grid, MenuItem, TextField, Button, Tooltip, ThemeProvider } from "@material-ui/core";
import "./UserMgntfile.css";
//import { tableIconsInputScreen } from "../../../Utilities/Utility";
import MaterialTable from "material-table";
import { forwardRef } from "react";
//import { saveData, updateData, getRolephy } from "./api_view";
import axios from 'axios';
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
//import DeleteOutline from "@material-ui/icons/EditOutlined";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import CircularProgress from '@material-ui/core/CircularProgress';
//import UpdateSlipInventory from "../../pages/UpdateSlipInventory/UpdateSlipInventory";
import UpdateUserMgnt from "../../pages/UserMgnt/UpdateUserMgnt";
import Alert from '@material-ui/lab/Alert';
import { TakingIdAction } from "../../ReduxStore/Actions/actions";
import { useDispatch, useSelector } from "react-redux";
import {
    AddBox,
    Check,
    DeleteOutline,
    Edit,
    SaveAlt,
    FilterList,
    FirstPage,
    LastPage,
    ChevronRight,
    ChevronLeft,
    Clear,
    Search,
    ArrowDownward,
    Remove,
    ViewColumn,
} from "@material-ui/icons";
import {
    withStyles,
} from '@material-ui/core/styles';
import Select from '@material-ui/core/Select';
import InputBase from '@material-ui/core/InputBase';
export const BootstrapInput = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 4,
        position: 'relative',
        backgroundColor: "var(--input-bg-color)",
        border: '1px solid var(--blue-green)',
        fontSize: 16,
        width: '100%',
        padding: '10px 12px',
    },
}))(InputBase);


export const tableIconsInputScreen = {
    Add: forwardRef((props, ref) => <AddBox  {...props} ref={ref} />),
    Check: forwardRef((props, ref) => (
        <Check {...props} style={{ fontSize: "large", padding: 0 }} ref={ref} />
    )),
    Clear: forwardRef((props, ref) => (
        <Clear {...props} style={{ fontSize: "large", padding: 0 }} ref={ref} />
    )),
    Delete: forwardRef((props, ref) => (
        <DeleteOutline {...props} ref={ref} style={{ color: "var(--red)" }} />
    )),
    DetailPanel: forwardRef((props, ref) => (
        <ChevronRight {...props} ref={ref} />
    )),
    Edit: forwardRef((props, ref) => (
        <Edit {...props} style={{ fontSize: "large", padding: 0 }} ref={ref} />
    )),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => (
        <ChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => (
        <Search {...props} ref={ref} style={{ fontSize: "2.5rem" }} />
    )),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};
const api = axios.create({
    baseURL: 'PhyInvUser'
})
const api_role = axios.create({
    baseURL: 'PhyInvRole'
})

//const tableHeaderStyle = {
//    backgroundColor: "var(--light-sand)",
//    color: "var(--dark-blue)",
//};

//export const tableOptionsUser = {
//    headerStyle: tableHeaderStyle,
//    showTitle: false,
//    draggable: false,
//    pageSize: 3,
//    // search: true,
//    // add: true,
//    pageSizeOptions: [5, 10, 25, 50],
//    paginationPosition: "bottom",
//    //paging: false,
//    maxBodyHeight: "600px",
//};

export const UserMgntFile = (props) => {
    //const token = useSelector((state) => state.saveTokenReducer.token);
   // const takingUidDataState = useSelector((state) => state.uIdValueReducer.uIdValue)
   // console.log("takingUidDataState", takingUidDataState);
   // const dispatch = useDispatch();
   
    const [firstName, setFirstName] = useState(props.loginuser.response.firstName);
    const [gid, setGid] = useState(props.loginuser.response.gid);
   
    const [userId, setUserId] = useState();
    const [userName, setUserName] = useState("");
    const [userEmailId, setUserEmailId] = useState("");
    const [plantName, setPlantName] = useState("");
    const [rolesId, setRolesId] = useState("");
    const [data, setData] = useState([]); //table data
    const [iserror, setIserror] = useState(false);
    const [errorMessages, setErrorMessages] = useState([]);
    const [open, setopen] = useState(false);
    const [openAlert, setopenAlert] = useState("");
    const [openClassName, setopenClassName] = useState("");
    const [openType, setopenType] = useState("");
    const [alertsuccess, setalertsuccess] = useState("Success");
    const [CreatedUserId, setCreatedUserId] = useState(props.loginuser.response.employeeId);
   // const [editRowData, seteditRowData] = useState([]);
    const [openForm, setopenForm] = useState(false);
    const [editRowData, seteditRowData] = useState([]);
    const [mode, setMode] = useState("");
    const [openLoader, setopenLoader] = useState(false);
    const [deleteRecordData, setDeleteRecordData] = useState(null);
    const token = useSelector((state) => state.saveAzureTokenReducer.token);
    const userDetails = useSelector(
      (state) => state.storeUserDetailsReducer.userData
    );
    const bearerToken = useSelector(
      (state) => state.saveBearerTokenReducer.bearerToken
    );
    const uId = useSelector((state) => state.saveUIDReducer.uid);
    //const [openLoader, setopenLoader] = useState(false);

    //const [showMessage, setShowMessage] = useState([]);

    //const [data, setData] = useState([]);
    const handleUserId = (e) => {
       
        setUserId(e.target.value);
    }
    const handleUserName = (e) => {
        
        setUserName(e.target.value);
    }
    const handleUserEmailId = (e) => {
        
        setUserEmailId(e.target.value);
    }
    const [plantId, setPlantId] = useState("");
    const handlePlantName = (e) => {
       
        setPlantId(e.target.value);
        
        getPlantNamesApi.map((x) => {
            if (x.plantId === e.target.value) {
                setPlantName(x.plantName);
            }
          
        })
    }
    function handleeditFormClose() {
        setopenForm(false);
    }
    const [openFormDelete, setOpenFormDelete] = useState(false);
    function handleeditFormCloseDelete() {
        setOpenFormDelete(false);
    }
    const handleErrorClose = (e) => {
        setIserror(false);
    }
    const goBackonClick = (obj) => {
        setopenForm(false);
        setopenLoader(false);
       
        if (obj) {
           // GetViewSlipDetails();
            //let errorList = [];
            //if (obj.result.objResult) {
            //}
            //errorList.push(obj.result.responseMsg);
            //if (obj.result.response) {
            //    showMessage(errorList, true, 'success');
            //}
            //else {
            //    showMessage(errorList, true, 'error');
            //}
        }
    }
    function GetEditButton(rowData) {
        return (
            <Tooltip title="Edit User" placement="bottom">
                <span>
                    <Button href="javascript:void(0)">
                        <span>
                            <EditOutlinedIcon fontSize="small" className="attachFileIcon" />
                        </span>
                    </Button>
                </span>
            </Tooltip>
        );
    }

    function GetDeleteButton(rowData) {
        return (
            <Tooltip title="Modify Slip" placement="bottom">
                <span>
                    <Button href="javascript:void(0)">
                        <span>
                            <DeleteOutline fontSize="small" className="attachFileIcon" />
                        </span>
                    </Button>
                </span>
            </Tooltip>
        );
    }
    function showMsg(popen, popenAlert, popenClassName, popenType) {
        setopen(popen);
        setopenAlert(popenAlert);
        setopenClassName(popenClassName);
        setopenType(popenType);
    }
    const [userRoleName, setUserRoleName] = useState("");
    const handleRolesId = (e) => {
        
        setRolesId(e.target.value);
        rolesData.map((x) => {
            if (x.roleId === e.target.value) {
                setUserRoleName(x.name);
            }
          
            
        })

    }
    
        
    
    const [rolesData, setRolesData] = useState([]);
    function RolesUsers() {
        //setopenLoader(true);
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        api_role.get("/GetAllRoles/",{
            headers: headers,
        })
            .then(res => {
                
                setRolesData(res.data);
                //setopenLoader(false);
            })
            .catch(error => {
                console.log("Error in hitting api : getAllRolesUsers!!")
                //setopenLoader(false);
            })
    }
    //GetAllPlantDetails
    const [getPlantNamesApi, setGetPlantNamesApi] = useState([]);
    function getPlantsName() {
        //setopenLoader(true);
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        api_role.get("/GetAllPlantDetails/",{
            headers: headers,
        })
            .then(res => {
                
                setGetPlantNamesApi(res.data);
                //setopenLoader(false);
            })
            .catch(error => {
                console.log("Error in hitting api : getAllRolesUsers!!")
                //setopenLoader(false);
            })
    }

    //GetUserDetails
    const [getAllDetailsData, setGetAllDetailsData] = useState([]);
    function getAllDetails() {
        setopenLoader(true);
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        //setopenLoader(true);
        api.get("/GetUserDetails/",{
            headers: headers,
        })
            .then(res => {
               
                setGetAllDetailsData(res.data);
                setopenLoader(false);
                //setopenLoader(false);
            })
            .catch(error => {
                console.log("Error in hitting api : GetUserDetails!!")
                //setopenLoader(false);
            })
    }

    useEffect(() => {
        //getAllRolesUsers(); 
        RolesUsers();
      
        getAllDetails();
        getPlantsName();
    }, [])
    //useEffect(() => {
    //    console.log("rolesData", rolesData);
    //    console.log("getAllDetailsData", getAllDetailsData);
    //    console.log("getPlantNamesApi", getPlantNamesApi);
    //}, [rolesData, getAllDetailsData, getPlantNamesApi])

    const clear = () => {
        setUserId("");
        setUserName("");
        setUserEmailId("");
        setRolesId("");
        setPlantId("");
        setPlantName("");
        setUserRoleName("");

    }
    const [severity, setSeverity] = useState('success');
    function showMessage(errorList, flag, severity) {
        setErrorMessages(errorList);
        setIserror(flag);
        setSeverity(severity);
    }
   

    function validateEmail(email) {

        var reg = (/^\w+([\.-]?\w+)*@siemens.com$/);
        return reg.test(email);
       
    }
    function validateUserId(userId) {
 
        var reg = (/^[A-Za-z0-9]{8}$/);
       return reg.test(userId);
       
    }
 

     

    const handleRowUpdate = (newData, oldData, resolve) => {
       
        //dispatch(TakingIdAction(newData.id));
        let errorList = [];
        

        if (errorList.length < 1) {
            let userUpdateDetails = {
                Id: newData.id,
                UserId: userId,
                UserName: userName,
                EmailAddress: userEmailId,
                PlantName: plantName,
                UserRoleName: userRoleName,
                UserRoleId: rolesId,//string chahiye--rolesId
                CreatedDate: null,
                CreatedBy: null,
                ModifiedDate: null,
                ModifiedBy: null,
                IsActive: true,



            }
          
            clickEdit(newData);
            
       
        

        } 
            else {
            setErrorMessages(errorList);
            setIserror(true);
            
        }
    }

    const handleRowAdd = () => {
        let errorList = [];
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        let userEnterDetails = {
            UserId: userId,
            UserName: userName,
            EmailAddress: userEmailId,
            PlantName: plantName,// plantName
            UserRoleName: userRoleName,
            UserRoleId: rolesId,//string chahiye--rolesId
            PlantId: plantId,
            CreatedDate: null,
            CreatedBy: null,
            ModifiedDate: null,
            ModifiedBy: null,
            IsActive: true,


        }
       
        let isValidate = true;
        if (userEnterDetails.UserId === "" || userEnterDetails.UserId === undefined || userEnterDetails.UserId === null) {
            isValidate = false;
            errorList.push("Please enter UserId");
          
            showMessage(errorList, true, 'error');
          
        } 

        if (userEnterDetails.UserId) {
           
            let validateData = validateUserId(userEnterDetails.UserId);
            if (!validateData) {
                errorList.push("Please enter Valid UserId");
 
                showMessage(errorList, true, 'error');
                return;
            }
        }
        
        if (userEnterDetails.UserName === "" || userEnterDetails.UserName === undefined || userEnterDetails.UserName === null) {
            isValidate = false;
            errorList.push("Please enter User Name");
           
            showMessage(errorList, true, 'error');
            

        } 
        if (userEnterDetails.EmailAddress === "" || userEnterDetails.EmailAddress === undefined || userEnterDetails.EmailAddress === null) {
            isValidate = false;
            errorList.push("Please enter User Email Id");
          
            showMessage(errorList, true, 'error');
            

        } 
        if (userEnterDetails.EmailAddress) {
           
            let validateData = validateEmail(userEnterDetails.EmailAddress);
            if (!validateData) {
                errorList.push("Please enter Valid Email");

                showMessage(errorList, true, 'error');
                return;
            }
            
            
        }
        if (userEnterDetails.PlantId === "" || userEnterDetails.PlantId === undefined || userEnterDetails.PlantId === null) {
            isValidate = false;
            errorList.push("Please enter User Plant Name");
          
            showMessage(errorList, true, 'error');
            //return;

        } 
        if (userEnterDetails.UserRoleId === "" || userEnterDetails.UserRoleId === undefined || userEnterDetails.UserRoleId === null) {
            isValidate = false;
            errorList.push("Please enter User Role");
           
            showMessage(errorList, true, 'error');
            

        } 
      
        if (isValidate) {
            
            api.post("/SaveUser/", userEnterDetails,{headers: headers})
                .then(res => {
                    if (res && res.data.result.objResult==true) {
                        

                        let dataToAdd = [...data];
                       
                        dataToAdd.push(userEnterDetails);
                        setData(dataToAdd);
                        errorList.push("Record were Added successfully!!!");
                        showMessage(errorList, true, 'success');
                        setIserror(true);
                        getAllDetails();
                    }
                    else {
                        errorList.push(res.data.result.responseMsg);
                        showMessage(errorList, true, 'success');
                        setIserror(true);

                    }
                    
                })
                .catch(error => {
                    setErrorMessages(["Due to server error, we are unable to add the employee. Please try again, later."]);
                    setIserror(true)
                    //resolve()
                })
        } else {
            setErrorMessages(errorList)
            setIserror(true)
            //resolve()
        }
    }

    const handleRowDelete = (oldData, resolve) => {
        let errorList = [];
       
        setDeleteRecordData(oldData);
        setOpenFormDelete(true);
    }
    
    const deleteRecord = () => {
        let errorList = [];
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        api.delete("/DeleteUser/" + deleteRecordData.id,{
            headers: headers,
        })
            .then(res => {
                

                const dataDelete = [...data];
                const index = deleteRecordData.tableData.id; 
                dataDelete.splice(index, 1);
                setData([...dataDelete]);
                setOpenFormDelete(false);
                setDeleteRecordData(null);
                errorList.push("Record is Deleted successfully!!!");
                showMessage(errorList, true, 'success');

                //errorList.push("");
                //setErrorMessages([]);
                setIserror(true);
                getAllDetails();

            })
            .catch(error => {
                setErrorMessages(["Delete failed! Server error"])
                setIserror(true)
                //resolve()
            })


    }
        
    //}


    //const [editRowData, setEditRowData] = useState(null);
    function clickEdit(rowData) {

        setMode("edit");
        setopenForm(true);
        seteditRowData(rowData);
    }









        var columns = [
            { title: "Options", field: "view", hidden: true },//hidden: true
            { title: "User Id", field: "userId" },
            { title: "User Name", field: "userName" },
            { title: "Email Address", field: "emailAddress" },//EmailAddress-->userEmailId-->emailAddress
            { title: "Plant Name", field: "plantName" },
            { title: "Role", field: "userRoleName" },

        ]
        return (
            <ThemeProvider theme={lightTheme}>
                <div className="master-layout-data">
                    <Grid className="profile-data">
                        <h5><span className="profile-info">{firstName}</span></h5>
                        <h5><span className="profile-info">{gid}</span></h5>
                    </Grid>

                    <Box >
                        <h3 className="clr-dark-blue d-flex jc-center  mb-1">User Master</h3>
                    </Box>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={4} className="d-flex Width-100 mt-1 ">
                            <TextField className="lightInputFields"

                                //disabled={true}
                                label="User Id"
                                variant="filled"
                                fullWidth
                                //name="Created Time"
                                onChange={handleUserId}

                                value={userId}

                            />



                        </Grid>

                        <Grid item xs={12} sm={4} className="d-flex Width-100 mt-1 ">
                            <TextField className="lightInputFields"

                                //disabled={true}
                                label=" User Name"
                                variant="filled"
                                fullWidth
                                onChange={handleUserName}
                                //disabled={userDetails.roleId == 1 || userDetails.roleId == 2 || userDetails.roleId == 3 || userDetails.roleId == 4 || userDetails.roleId == 5 || userDetails.roleId == 7 || userDetails.roleId == 8 || userDetails.roleId == 9 || userDetails.roleId == 10}
                                value={userName}


                            />
                        </Grid>

                        <Grid item xs={12} sm={4} className="d-flex Width-100 mt-1 ">
                            <TextField className="lightInputFields"

                                //disabled={true}
                                label=" Email Address"
                                variant="filled"
                                fullWidth
                                onChange={handleUserEmailId}
                                //disabled={userDetails.roleId == 1 || userDetails.roleId == 2 || userDetails.roleId == 3 || userDetails.roleId == 4 || userDetails.roleId == 5 || userDetails.roleId == 7 || userDetails.roleId == 8 || userDetails.roleId == 9 || userDetails.roleId == 10}
                                value={userEmailId}


                            />
                        </Grid>

                        <Grid item xs={12} sm={4} className="d-flex Width-100  mt-1">
                            <TextField className="lightInputFields  "
                                select
                                id=""
                                //disabled={true}
                                label="Plant Name"
                                variant="filled"
                                fullWidth
                                name=""
                                value={plantId}
                                onChange={handlePlantName}
                            >

                                {getPlantNamesApi.map((item) => (
                                    <MenuItem key={item.plantId} value={item.plantId}>
                                        {item.plantName}
                                    </MenuItem>
                                ))}
                            </TextField>


                        </Grid>



                        <Grid item xs={12} sm={4} className="d-flex Width-100  mt-1">
                            <TextField className="lightInputFields"
                                select
                                id="roledfiled"
                                //disabled={true}
                                label="Roles"
                                variant="filled"
                                fullWidth
                                name=""
                                value={rolesId}
                                onChange={handleRolesId}
                            >
                                {rolesData.map((item) => (
                                    <MenuItem key={item.roleId} value={item.roleId}>
                                        {item.name}
                                    </MenuItem>
                                ))}
                            </TextField>


                        </Grid>




                    </Grid>
                    <Grid className="btn-section">

                        <Grid item xs={12} sm={2} className="d-flex jc-center width-20">
                            <Button className="ns-btn-primary mt-1 mr-1" onClick={handleRowAdd} >
                                <span>Add</span>
                            </Button>
                        </Grid>

                        <Grid item xs={12} sm={2} className="d-flex jc-center width-100">
                            <Button className="ns-btn-primary mt-1 mr-1" onClick={clear}>
                                <span>Clear</span>
                            </Button>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={12} className="userManagement mt-1 mb-1">
                        <div>
                            {iserror &&
                                <Alert severity={severity} onClose={handleErrorClose}>
                                    {errorMessages.map((msg, i) => {
                                        return <div key={i}>{msg}</div>
                                    })}
                                </Alert>
                            }
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid item sx={12}>
                            <MaterialTable

                                title=""
                                columns={columns}
                                data={getAllDetailsData}

                                icons={tableIconsInputScreen}
                                actions={[

                                    rowData => ({
                                        icon: GetEditButton,

                                        tisFreeAction: true,

                                        onClick: (event, rowData) => handleRowUpdate(rowData),
                                    }),
                                    rowData => ({
                                        icon: DeleteOutline,

                                        tisFreeAction: true,

                                        onClick: (event, rowData) => handleRowDelete(rowData),
                                    }),



                                ]}
                                options={{ exportButton: {csv: true } }}



                            />
                        </Grid>
                    </Grid>
                    <Dialog
                        open={openLoader}
                        //onClose={handleClose}
                        aria-labelledby="draggable-dialog-title"
                        id="templateUploadSuccess"
                        PaperProps={{
                            style: {
                                backgroundColor: "transparent",
                                boxShadow: "none",
                                borderColor: "transparent"
                            },
                        }}>
                        <DialogContent>
                            <CircularProgress />
                        </DialogContent>
                    </Dialog>


                    <Dialog
                        open={openForm}
                        disableBackdropClick
                        maxWidth={"lg"}
                        aria-labelledby="edit-dialog-title"
                        onClose={handleeditFormClose}
                    >
                        <DialogContent>

                            <UpdateUserMgnt setopenForm1={setopenForm} setGetAllDetailsData1={setGetAllDetailsData} userRolesData={rolesData} plantNameData={getPlantNamesApi} clickgoback={goBackonClick} editData={editRowData} Mode={mode} createdUserId={CreatedUserId} />

                        </DialogContent>
                    </Dialog>

                    <Dialog
                        open={openLoader}
                        //onClose={handleClose}
                        aria-labelledby="draggable-dialog-title"
                        id="templateUploadSuccess"
                        PaperProps={{
                            style: {
                                backgroundColor: "transparent",
                                boxShadow: "none",
                                borderColor: "transparent"
                            },
                        }}>
                        <DialogContent>
                            <CircularProgress />
                        </DialogContent>
                    </Dialog>

                    <Dialog
                        open={openFormDelete}
                        disableBackdropClick
                        maxWidth={"lg"}
                        aria-labelledby="edit-dialog-title"
                        onClose={handleeditFormCloseDelete}
                    >
                        <DialogContent>
                            <Grid className="delete-popup">
                                Are you really want to delete the record?
                                <Grid className="delete-popup">
                                    <div item xs={12} sm={2} className="d-flex jc-center width-100">
                                        <Button className="ns-btn-primary mt-1 mr-1" onClick={deleteRecord} >
                                            <span>Yes</span>
                                        </Button>
                                    </div>
                                    <div item xs={12} sm={2} className="d-flex jc-center width-100">
                                        <Button className="ns-btn-primary mt-1 mr-1" onClick={() => { setOpenFormDelete(false); setDeleteRecordData(null) }} >
                                            <span>No</span>
                                        </Button>
                                    </div>
                                </Grid>

                            </Grid>


                        </DialogContent>
                    </Dialog>


                </div>

            </ThemeProvider>

        );
    
}
